'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconToggle = require('./IconToggle');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconToggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/IconToggle/index.js
// module id = 292
// module chunks = 0